// Extrae un mensaje legible de un error de axios proveniente del backend (DRF).
// Soporta las formas:
//   "texto plano"
//   { detail: "..." }
//   { timezone: ["..."] }
//   { business_hours: ["..."] }
//   { business_hours: [ { start_time: ["..."] } ] }
//   { campo: ["..."] }
const HTML_RESPONSE_PATTERN = /^\s*(<!doctype|<html|<head|<body)/i;
const MAX_READABLE_LENGTH = 300;

const readableMessage = (value) => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > MAX_READABLE_LENGTH) return null;
  if (HTML_RESPONSE_PATTERN.test(trimmed)) return null;
  return trimmed;
};

export function extractApiErrorMessage(error) {
  const data = error?.response?.data;
  if (!data) return null;
  if (typeof data === "string") return readableMessage(data);

  if (typeof data.detail === "string") return readableMessage(data.detail);

  const firstString = (value) => {
    if (typeof value === "string") return readableMessage(value);
    if (Array.isArray(value)) {
      for (const item of value) {
        if (typeof item === "string") {
          const readable = readableMessage(item);
          if (readable) return readable;
        } else if (item && typeof item === "object") {
          const nested = Object.values(item)[0];
          const resolved = firstString(nested);
          if (resolved) return resolved;
        }
      }
    }
    return null;
  };

  for (const value of Object.values(data)) {
    const message = firstString(value);
    if (message) return message;
  }

  return null;
}

export const MAILBOX_REAUTH_CODE = "mailbox_reauth_required";

export function extractMailboxReauth(error) {
  const data = error?.response?.data;
  if (!data || typeof data !== "object") return null;
  if (data.code !== MAILBOX_REAUTH_CODE) return null;

  return {
    provider: data.provider,
    email: data.email,
    oauthAccountId: data.oauth_account_id,
    tenantId: data.tenant_id,
    message: data.detail || data.error || null,
  };
}
